// @/services/ReviewsClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const reviewsOptions = {
  baseUrl: `${BACK_END_URL}/reviews`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class ReviewsClient extends CandyClient {
  constructor() {
    super(reviewsOptions);
  }

  async getCourseReviews(courseId) {
    return this.get(`/course/${courseId}`);
  }

  async createReview(courseId, reviewData) {
    return this.post(`/course/${courseId}`, reviewData);
  }
}